const StandardToaster = ({ text }) => {
  return <div className="standard-toaster">{text}</div>;
};

export default StandardToaster;
